import * as zExt from "@redotech/rpc/ext";
import * as z from "zod";

export const getHsaSettings = {
  name: "getHsaSettings" as const,
  input: z.object({ teamId: zExt.objectId() }),
  output: z.object({
    enabled: z.boolean(),
    reorderHsaPaymentMethodToTop: z.boolean(),
    canModifyCreditCardPaymentMethods: z.boolean(),
    /** The store's last-synced Shopify plan; null until the plan has been synced. */
    shopifyPlan: z
      .object({ displayName: z.string(), lastSyncedAt: z.date() })
      .nullable(),
    sendGalePaymentInfoSubmittedEvents: z.boolean(),
    checkoutButtonsSkipShopPay: z.boolean(),
    redoHandlesPaymentSessions: z.boolean(),
    /** Which storefront element interactions float HSA/FSA at checkout. */
    intentSignals: z.object({
      lmnStarted: z.boolean(),
      lmnCompleted: z.boolean(),
      pdpWidget: z.boolean(),
      cartWidget: z.boolean(),
    }),
  }),
};
export type GetHsaSettingsOutput = z.infer<typeof getHsaSettings.output>;
